import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { TranslateModule } from "@ngx-translate/core";

import { LoadingIndicatorComponent } from "./inline/loading-indicator.component";
import { ProgressBarComponent } from "./progress-bar/progress-bar.component";
import { SpinnerComponent } from "./spinner/spinner.component";

@NgModule({
	imports: [CommonModule, TranslateModule, MatProgressBarModule],
	declarations: [LoadingIndicatorComponent, SpinnerComponent, ProgressBarComponent],
	exports: [LoadingIndicatorComponent, SpinnerComponent, ProgressBarComponent],
})
export class LoadingIndicatorModule {}
